<template>
    <div class="block-type-container" :class="{'block-type-container--filtered': filtered}">
        <span class="type-title">{{ menuTitle || block.label }}</span>
        <template v-if="!menuTitle">
            <span class="message" v-if="!block.controls.length && !blockSecond.controls.length && blockListSearchTerm">No Search Results</span>
        </template>

		<div ref="container" class="block-type-container--inner scrollable-con">
            <template v-if="menuTitle">
                <span class="type-sub-title my-3 d-block">
                    {{ block.label }}
                    <v-icon v-if="showSubmenuIcon" size="18" class="fas fa-magic ml-1 color-accent-gradient"></v-icon>
                </span>
                <span class="message px-1" v-if="!block.controls.length && !blockSecond.controls.length && blockListSearchTerm">No Search Results</span>
            </template>

            <div v-for="control in block.controls" :key="control.category" class="control-name"
                 @click="onClick(control)"
                 :class="{'control-name--prominent': control.showNewLabel || control.showImprovedLabel}" :data-name="control.name"
                 :data-category="control.category">
                <v-icon class="mr-1" :class="getIconClass(control.iconClass)" :size="getIconSize(control.iconSize)">{{ control.icon }}</v-icon>
                <div class="control-label">
                    {{ control.label }}
                    <span v-if="control.showNewLabel" class="control-label--new">NEW</span>
                    <span v-if="control.showImprovedLabel" class="control-label--new">Improved</span>
                </div>
            </div>

            <template v-if="blockSecond.type">
                <span class="type-sub-title mt-6 mb-3 d-block">{{ blockSecond.label }}</span>
                <span class="message px-1" v-if="!blockSecond.controls.length && blockListSearchTerm">No Search Results</span>

                <div v-for="control in blockSecond.controls" :key="control.category" class="control-name"
                     @click="onClick(control)"
                     :class="{'control-name--prominent': control.showNewLabel || control.showImprovedLabel}" :data-name="control.name"
                     :data-category="control.category">
                    <v-icon class="mr-1" :class="getIconClass(control.iconClass)" :size="getIconSize(control.iconSize)">{{ control.icon }}</v-icon>
                    <div class="control-label">
                        {{ control.label }}
                        <span v-if="control.showNewLabel" class="control-label--new">NEW</span>
                        <span v-if="control.showImprovedLabel" class="control-label--new">Improved</span>
                    </div>
                </div>
            </template>

            <template v-if="blockThird.type">
                <span class="type-sub-title mt-6 mb-3 d-block">{{ blockThird.label }}</span>
                <span class="message px-1" v-if="!blockThird.controls.length && blockListSearchTerm">No Search Results</span>

                <div v-for="control in blockThird.controls" :key="control.category" class="control-name"
                     @click="onClick(control)"
                     :class="{'control-name--prominent': control.showNewLabel || control.showImprovedLabel}" :data-name="control.name"
                     :data-category="control.category">
                    <v-icon class="mr-1" :class="getIconClass(control.iconClass)" :size="getIconSize(control.iconSize)">{{ control.icon }}</v-icon>
                    <div class="control-label">
                        {{ control.label }}
                        <span v-if="control.showNewLabel" class="control-label--new">NEW</span>
                        <span v-if="control.showImprovedLabel" class="control-label--new">Improved</span>
                    </div>
                </div>
            </template>
        </div>

		<div v-show="showArrow" ref="arrowContainer" class="arrow-down-container" :class="{'--is-disabled': arrowDisabled}">
			<v-icon color="var(--font-default-color)" class="material-symbols-outlined">keyboard_arrow_down</v-icon>
		</div>
    </div>
</template>

<script>

import { mapGetters, mapState } from "vuex";

export default {
	data() {
		return {
			showArrow: false,
			arrowDisabled: false
		}
	},

    props: {
        filtered: Boolean,
        menuTitle: String,
        showSubmenuIcon: Boolean,
        block: {
            type: Object,
            default: () => {
                return {
                    type: null,
                    label: null,
                    controls: []
                }
            }
        },
        blockSecond: {
            type: Object,
            default: () => {
                return {
                    type: null,
                    label: null,
                    controls: []
                }
            }
        },
        blockThird: {
            type: Object,
            default: () => {
                return {
                    type: null,
                    label: null,
                    controls: []
                }
            }
        }
    },

	mounted() {
		this.$refs.container.addEventListener('scroll', e => {
			if (this.$refs.container.scrollHeight - this.$refs.container.scrollTop - this.$refs.container.clientHeight < 1) {
				this.arrowDisabled = true
			} else {
				this.arrowDisabled = false;
			}
		});

		let interval;

		this.$refs.arrowContainer.addEventListener("mouseenter", () => {
			interval = setInterval(() => this.$refs.container.scrollTop += 1, 10);
		});

		this.$refs.arrowContainer.addEventListener("mouseleave", () => {
			clearInterval(interval);
		});
	},

    computed: {
        ...mapState('App', ['blockLoading']),
		...mapState('UI', ['blockListSearchTerm', 'leftColumn']),
        ...mapGetters('User', ['isCurrentPlanFree'])
    },

	watch: {
		leftColumn(newValue) {
			if (!['controlBlocks', 'creativeBlocks', 'magicModeBlocks'].includes(newValue)) return;

			if (this.$refs.container.scrollHeight > this.$refs.container.clientHeight) {
				this.showArrow = true;
			} else {
				this.showArrow = false;
			}
		},

		blockListSearchTerm() {
			this.$nextTick(() => {
				if (this.$refs.container.scrollHeight > this.$refs.container.clientHeight) {
					this.showArrow = true;
				} else {
					this.showArrow = false;
				}
			})
		}
	},

    methods: {
        getIconClass(iconClass) {
            if (iconClass) return [iconClass];
            else return ['material-icons']
        },

        getIconSize(iconSize) {
            if (iconSize) return iconSize;
            else return 18;
        },

        async onClick(control) {
            if (this.blockLoading) return;

            // this.$store.dispatch('UI/setAddBlockMenu', false);

            if ((control.name == "customLUT" || control.name == "CustomLutV2") && this.isCurrentPlanFree) {
                window.UI.showModal(window.UI.modals.notAvailableInFree.el);
                return;
            }

            this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks');

            const data = {
                control: control.name,
                category: control.category,
                initial: true,
            };

            if (data.control == 'AIMagicMode') {
                this.$root.$refs.addMagicModeButton.$el.click();
                return;
            }

            if (data.control == 'LegacyMagicMode') {
                if (window.lutify.magicMode.isApplied) {
                    let firstControlName = window._Adjustments.magicMode.controls[0].name;
                    let firstControlCategory = window._Adjustments.magicMode.controls[0].category;

                    // Only trigger click action if the first category of magic mode is fully loaded and if the current active block is not magicMode or no selection at all (after compare applied)
                    if (
                        window.luts.loaded[firstControlName].controls[firstControlCategory] &&
                        (!window.lutify.getActiveBlock() || window.lutify.getActiveBlock().name !== "magicMode")
                    ) {
                        $("#blocks-container .magic-mode-block").trigger("click");
                    }
                } else {
                    window._Adjustments.magicMode.addBlock(window.blocks.getNewBlockNumber());
                }

				UI.toggleStartTips();

				return;
            }

            await window._Adjustments[data.control].addBlock(blocks.getNewBlockNumber(), data);
            window.lutify.storeLastState();

			UI.toggleStartTips();

			window.UI.scrollToBlock(lutify.activeBlock);
        }
    }
}
</script>

<style lang="scss" scoped>
.arrow-down-container {
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	cursor: pointer;

	&.--is-disabled {
		cursor: initial;
		opacity: 0.5;
	}
}
</style>

